import React, { Component } from 'react';
import { func, string, array } from 'prop-types';
import { slide as Menu } from 'react-burger-menu';

import Link from 'gatsby-link';
import { Header, Icon } from '..';

export default class Nav extends Component {
  static propTypes = {
    children: func,
    logo: string,
    logoMobile: string,
    menuBtn: string,
    items: array,
  };

  state = {
    menuOpen: false,
  };

  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  render() {
    const {
      children,
      data,
      className,
      logo,
      logoMobile,
      menuBtn,
      items,
      ...other
    } = this.props;

    const renderMenuItems =
      items &&
      items.map((item, itemIndex) => (
        <Link
          className="btn btn--link"
          key={itemIndex}
          to={item.url}
          onClick={() => this.closeMenu()}
        >
          {item.title}
        </Link>
      ));

    return (
      <div className="className" {...other}>
        <Menu
          width="280px"
          pageWrapId="page-wrap"
          isOpen={this.state.menuOpen}
          right
          onStateChange={state => this.handleStateChange(state)}
          customBurgerIcon={false}
        >
          {renderMenuItems}
        </Menu>
        <Header
          logo={logo}
          logoMobile={logoMobile}
          renderButton={() => (
            <Icon
              className="nav__btn"
              name={menuBtn}
              onClick={() => this.toggleMenu()}
            />
          )}
        />
      </div>
    );
  }
}
